/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkspaceEndpoint
 */
export interface WorkspaceEndpoint {
    /**
     * 
     * @type {string}
     * @memberof WorkspaceEndpoint
     */
    protocol: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceEndpoint
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceEndpoint
     */
    path: string;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceEndpoint
     */
    priority: number;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceEndpoint
     */
    platform: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceEndpoint
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceEndpoint
     */
    password: string;
}

export function WorkspaceEndpointFromJSON(json: any): WorkspaceEndpoint {
    return WorkspaceEndpointFromJSONTyped(json, false);
}

export function WorkspaceEndpointFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceEndpoint {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'protocol': json['protocol'],
        'address': json['address'],
        'path': json['path'],
        'priority': json['priority'],
        'platform': json['platform'],
        'username': json['username'],
        'password': json['password'],
    };
}

export function WorkspaceEndpointToJSON(value?: WorkspaceEndpoint | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'protocol': value.protocol,
        'address': value.address,
        'path': value.path,
        'priority': value.priority,
        'platform': value.platform,
        'username': value.username,
        'password': value.password,
    };
}


